'use client';

import { Field, Label, Switch } from '@headlessui/react';
import { Ref, useEffect, useState } from 'react';
import { VariantProps } from 'tailwind-variants';

import { styles } from './UiKitToggleBase.styles';

type Variants = VariantProps<typeof styles>;

export interface UiKitToggleBaseProps {
  label?: string;
  error?: boolean;
  disabled?: boolean;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  helperText?: string;
  ref?: Ref<HTMLButtonElement>;
  checkedView?: Variants['checkedView'];
  className?: string;
  labelClassName?: string;
  color?: VariantProps<typeof styles>['color'];
  as?: 'button' | 'div';
}

export function UiKitToggleBase({
  label,
  error,
  disabled,
  checked: initialChecked,
  onChange,
  helperText,
  ref,
  as = 'button',
  checkedView,
  className,
  labelClassName,
  color,
  ...props
}: UiKitToggleBaseProps) {
  const slots = styles({ error, checkedView, color });

  const [checked, setChecked] = useState(initialChecked);

  useEffect(() => {
    setChecked(initialChecked);
  }, [initialChecked]);

  const handleChange = (checked: boolean) => {
    setChecked(checked);
    onChange?.(checked);
  };

  return (
    <Field
      className={slots.base({ className })}
      disabled={disabled}
    >
      <div>
        <Switch
          as={as}
          ref={ref}
          checked={checked}
          onChange={handleChange}
          className={slots.toggle()}
          {...props}
        >
          <div className={slots.switch()}>
            <span className={slots.dot()} />
          </div>
          {label && (
            <Label className={slots.label({ className: labelClassName })}>
              {label}
            </Label>
          )}
        </Switch>
        {helperText && <p className={slots.helperText()}>{helperText}</p>}
      </div>
    </Field>
  );
}
